import apiClient from 'api/apiClient';
import API_END_POINT from 'constants/apiEndPoints';
import { ApiResponse } from 'types';

type UpdateConfirmAlarm = () => Promise<ApiResponse>;

const updateConfirmAlarm: UpdateConfirmAlarm = async () => {
  const { data } = await apiClient.put(API_END_POINT.USER.UPDATE_CONFIRM_ALARM);

  return data;
};

export default updateConfirmAlarm;
